export default __webpack_public_path__ + "components/wind-icon/static/NNW@2x-8478e2d1b894850d56cd5427e305a9b8.png";